/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Form, withFormik } from 'formik';
import * as Yup from 'yup';
import AutoInput from '../AutoInput';
import { Input, PhoneNumber } from '../../../ui/Form';
import * as Styles from './index.styles';
import { get } from 'lodash';
import { DEFAULT_COUNTRY } from '../../../../utils/constants';
// src\components\ui\Form\PhoneNumberField\index.js

const phoneRegExp = /^(\\+)?([ .\-()0-9]){10,12}$/;

const formSchema = Yup.object().shape({
  name: Yup.string().required('this is a mandatory field'),
  email: Yup.string()
    .email('Invalid email')
    .required('this is a mandatory field'),
  phoneNumber: Yup.string()
    .required('this is a mandatory field')
    .matches(phoneRegExp, 'Phone number is not valid'),
});

const UserInfoForm = props => {
  const {
    values,
    touched,
    errors,
    handleChange,
    // handleBlur,
    handleSubmit,
    PhoneNumberWatermark,
    EmailWatermark,
    NameWatermark,
    setCountryData,
    setFieldValue,
  } = props;

  const PhoneNumberOptions = get(props, 'fields.PhoneNumberOptions', []);
  const defaultPhoneValue = values.CountryISOCode2
    ? values.CountryISOCode2
    : get(props, 'fields.DomainCountryISOCode2.value', DEFAULT_COUNTRY);

  return (
    <Form onSubmit={handleSubmit} css={Styles.formInputHolder}>
      <div className="TypeAheadDropDown" css={[Styles.TypeAheadDropDown]}>
        <Input
          id="name"
          onChange={handleChange}
          value={values.name}
          placeholder={NameWatermark}
          error={errors.name && touched.name}
          errorMessage={errors.name}
          className="typeHeadeInput-holder"
        />
      </div>
      <div className="TypeAheadDropDown" css={[Styles.TypeAheadDropDown]}>
        <Input
          id="email"
          type="email"
          onChange={handleChange}
          placeholder={EmailWatermark}
          value={values.email}
          error={errors.email && touched.email}
          errorMessage={errors.email}
          className="typeHeadeInput-holder"
        />
      </div>
      <div className="TypeAheadDropDown" css={[Styles.TypeAheadDropDown]}>
        <PhoneNumber
          innerCss={{ container: Styles.container }}
          placeholder={PhoneNumberWatermark}
          inputProps={{ name: 'phoneNumber', value: values.phoneNumber }}
          onChange={handleChange}
          className="typeHeadeInput-holder1"
          defaultValue={defaultPhoneValue}
          error={errors.phoneNumber && touched.phoneNumber}
          errorMessage={errors.phoneNumber}
          options={PhoneNumberOptions}
          onInit={({ countryData }) => {
            setCountryData(countryData);
          }}
          onChangeProp={(_event, countryData) => {
            setCountryData(countryData);
          }}
        />
      </div>
      <input
        name="CountryISOCode2"
        type="hidden"
        onChange={handleChange}
        value={values.CountryISOCode2}
      />
      <input
        name="DialingCode"
        type="hidden"
        value={values.DialingCode}
        onChange={handleChange}
      />
      <input
        name="CountryISOCode3"
        type="hidden"
        value={values.CountryISOCode3}
        onChange={handleChange}
      />

      {/* <button type="submit">Submit</button> */}
    </Form>
  );
};

class UserInfo extends React.Component {
  state = { CountryISOCode2: '', DialingCode: '', CountryISOCode3: '' };
  componentDidMount() {
    const {
      setValidationAction,
      submitForm,
      CountryISOCode2,
      DialingCode,
    } = this.props;
    if (setValidationAction) {
      setValidationAction(submitForm);
    }

    this.setState({
      CountryISOCode2: CountryISOCode2,
      DialingCode: DialingCode,
    });
  }

  setCountryData = countryData => {
    const { setFieldValue } = this.props;
    this.countryData = countryData;
    setTimeout(() => {
      setFieldValue('CountryISOCode3', countryData.CountryISOCode3);
      setFieldValue('CountryISOCode2', countryData.CountryISOCode2);
      setFieldValue('DialingCode', countryData.DialingCode);
    }, 500);
    this.setState({
      CountryISOCode3: countryData.CountryISOCode3,
      CountryISOCode2: countryData.CountryISOCode2,
      DialingCode: countryData.DialingCode,
    });
  };

  render() {
    const { ...other } = this.props;
    return <UserInfoForm setCountryData={this.setCountryData} {...other} />;
  }
}

export default withFormik({
  mapPropsToValues: param => ({
    name: param.name,
    email: param.email,
    phoneNumber: param.phoneNumber,
    CountryISOCode2: param.CountryISOCode2,
    CountryISOCode3: param.CountryISOCode3,
    DialingCode: param.DialingCode,
  }),
  validationSchema: formSchema,
  handleSubmit: (values, param) => {
    const { setSubmitting, props } = param;
    if (props.onSaveStepData) {
      props.onSaveStepData(values);
    }
    setSubmitting(false);
  },

  displayName: 'UserInfoForm',
})(UserInfo);
